export default {
    view: "Ukázat více"
}